import { Copy, Trash2, Plus } from 'lucide-react'
import React from 'react'
import { Button } from '@/components/ui/button'
import styles from '@/styles/ContextMenu.module.css'

interface ContextMenuProps {
  id: string
  top?: number
  left?: number
  right?: number
  bottom?: number
  onDuplicate: (id: string) => void
  onDelete: (id: string) => void
  onCopy?: (id: string) => void
  onClose?: () => void // Add this prop
}

export default function ContextMenu({
  id,
  top,
  left,
  right,
  bottom,
  onDuplicate,
  onDelete,
  onCopy,
  onClose, // Add this prop
}: ContextMenuProps) {
  return (
    <div
      style={{
        position: 'absolute',
        top: top !== undefined ? `${top}px` : 'auto',
        left: left !== undefined ? `${left}px` : 'auto',
        right: right !== undefined ? `${right}px` : 'auto',
        bottom: bottom !== undefined ? `${bottom}px` : 'auto',
      }}
      className={styles.contextMenu}
    >
      <p className={styles.nodeId}>Node: {id}</p>

      {onCopy && (
        <Button
          variant="outline"
          size="sm"
          className="mr-1"
          onClick={() => {
            onCopy(id)
            if (onClose) onClose()
          }}
        >
          <Copy className="mr-2 h-4 w-4" />
          Copy to clipboard
        </Button>
      )}
      <Button
        variant="outline"
        size="sm"
        className="mr-1"
        onClick={() => {
          onDuplicate(id)
          if (onClose) onClose()
        }}
      >
        <Plus className="mr-2 h-4 w-4" />
        Duplicate
      </Button>
      <Button
        variant="outline"
        size="sm"
        onClick={() => {
          onDelete(id)
          if (onClose) onClose()
        }}
      >
        <Trash2 className="mr-2 h-4 w-4" />
        Delete
      </Button>
    </div>
  )
}
